// extracted by mini-css-extract-plugin
module.exports = {"container":"common-common-module--container--1Rsjr","russiaBackground":"common-common-module--russiaBackground--gDqjh"};